// extracted by mini-css-extract-plugin
export default {"wrapper":"DetectMoreAds_wrapper__eDZPV"};